import React from "react";
import { BadgeCheck } from "lucide-react";

// Shown only where the server says KYC is currently verified — the badge is
// derived from live KYC state, never from a sticky flag.
export const VerifiedBadge = ({ size = "md", showLabel = true, testId }) => {
  const iconClass = size === "sm" ? "w-3.5 h-3.5" : size === "lg" ? "w-5 h-5" : "w-4 h-4";
  if (!showLabel) {
    return (
      <BadgeCheck className={`${iconClass} text-primary shrink-0`} title="Verified instructor · ID and documents checked"
                  aria-label="Verified instructor" data-testid={testId} />
    );
  }
  return (
    <span
      className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-widest px-2 py-0.5 border border-primary text-primary bg-primary/5 shrink-0"
      title="Verified instructor · ID and documents checked by DriveTerrain"
      data-testid={testId}
    >
      <BadgeCheck className={iconClass} /> Verified
    </span>
  );
};

export default VerifiedBadge;
